module.exports = __webpack_public_path__ + "static/van-6503882c50ab0e456fbd8477b231abcd.png";